<template>
  <div class="take-points" v-show="isShow" @keydown.stop @mousedown.stop>
    <div
      class="points-backdrop"
      :style="{width: Window_Size.width + 'px', height: Window_Size.height + 'px'}"
      @click.self="backClick"
    >
      <div class="point-target" :style="{top: point.y + 'px', left: point.x + 'px'}"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isShow: false,
      sprite: null,
      point: {
        x: 0,
        y: 0
      },
      position: {
        top: 0,
        left: 0
      },
      spriteO: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    ...mapGetters([
      "Window_Size",
      "SelectSprites_Msg",
      "TOOL",
      "MaterialPane_Size",
      "TopNav_Size"
    ])
  },
  mounted() {
    this.$bus.on("take_points", data => {
      if (data.type === "open") {
        this.initData(data.data);
      } else {
        this.cancel();
      }
    });
  },
  methods: {
    initData(data) {
      if (
        data &&
        this.SelectSprites_Msg &&
        this.SelectSprites_Msg.length === 1
      ) {
        this.isShow = true;
        this.sprite = this.SelectSprites_Msg[0];
        this.spriteO.x =
          this.sprite.width / 2 +
          this.sprite.positionLeft +
          this.MaterialPane_Size.width +
          this.TOOL.fixLeft -
          13;
        this.spriteO.y =
          this.sprite.height / 2 +
          this.sprite.positionTop +
          this.TopNav_Size.height +
          this.TOOL.fixTop +
          27;
        this.position.top = data.top;
        this.position.left = data.left;
        this.pos2point();
      } else {
        this.cancle();
      }
    },
    pos2point() {
      let point = { x: 0, y: 0 };
      point.x =
        this.position.left * this.sprite.width +
        this.sprite.positionLeft +
        this.MaterialPane_Size.width +
        this.TOOL.fixLeft -
        13;
      point.y =
        this.position.top * this.sprite.height +
        this.sprite.positionTop +
        this.TopNav_Size.height +
        this.TOOL.fixTop +
        27;

      point = this._rotateWithPoint(point, this.spriteO, this.sprite.rotate);
      console.log(point, this.spriteO, this.sprite.rotate);
      this.point.x = point.x;
      this.point.y = point.y;
    },
    point2pos() {
      let position = this._rotateWithPoint(
        this.point,
        this.spriteO,
        -this.sprite.rotate
      );
      this.position.left =
        (position.x -
          this.sprite.positionLeft -
          this.MaterialPane_Size.width -
          this.TOOL.fixLeft +
          13) /
        this.sprite.width;
      this.position.top =
        (position.y -
          this.sprite.positionTop -
          this.TopNav_Size.height -
          this.TOOL.fixTop -
          27) /
        this.sprite.height;
      this.$bus.emit("output_points", {
        left: this.position.left,
        top: this.position.top
      });
    },
    backClick(e) {
      this.point.x = e.pageX - 13;
      this.point.y = e.pageY - 13;
      this.point2pos();
      this.$analysis({
        category: "rotate_animation_panel",
        action: "click_dot",
        label: "旋转动画面板-打点"
      });
    },
    cancel() {
      this.isShow = false;
      this.sprite = null;
    },
    _rotateWithPoint: function(a, o, deg = 0) {
      //点a围绕o点旋转deg(顺时针)角度后的位置
      var b = {};
      deg = (Math.PI / 180) * deg;
      b.x = (a.x - o.x) * Math.cos(deg) - (a.y - o.y) * Math.sin(deg) + o.x;
      b.y = (a.x - o.x) * Math.sin(deg) + (a.y - o.y) * Math.cos(deg) + o.y;

      return b;
    }
  }
};
</script>

<style lang="scss" scoped>
.take-points {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 25;
}
.points-backdrop {
  position: fixed;
  background-color: rgba(248, 248, 248, 0.75);
}
.point-target {
  position: absolute;
  width: 26px;
  height: 26px;
  background: url("../../static/svg/icon-whirl-position.svg") no-repeat center;
}
</style>



// WEBPACK FOOTER //
// src/components/TakePoints.vue